import { Component, Inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { ProgressSpinnerComponent } from './widgets/progress-spinner/progress-spinner.component';
import { LoadingService } from './services/loading.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PopupType } from './widgets/app-popup/app-popup.component';
import {
  MSAL_GUARD_CONFIG,
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalModule,
  MsalService,
} from '@azure/msal-angular';
import {
  AuthenticationResult,
  InteractionStatus,
  PopupRequest,
  RedirectRequest,
  EventMessage,
  EventType,
  AuthError,
} from '@azure/msal-browser';
import { filter, Subject, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { AccessDeniedPopupComponent } from './widgets/access-denied-popup/access-denied-popup.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, MsalModule, RouterOutlet, ProgressSpinnerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'UI';
  isIframe = false;
  loginDisplay = false;
  loggedinUserName: any;
  private readonly _destroying$ = new Subject<void>();
  constructor(
    private loadingService: LoadingService,
    private router: Router,
    private dialog: MatDialog,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService
  ) {
    // session id logic for Sparci(to open in new tab)
    const sessionValue = new URLSearchParams(window.location.search);
    const sessionId = sessionValue.get('sessionid');
    if (sessionId != null) {
      sessionStorage.setItem('sessionId', sessionId);
    } else {
      sessionStorage.getItem('sessionId');
    }

    //to get project details
    const projParams = new URLSearchParams(window.location.search);
    const projId = projParams.get('projectID');
    if (projId != null) {
      localStorage.setItem('projectId', projId);
    } else {
      localStorage.getItem('projectId');
    }

    //to get user id
    const userIdValue = new URLSearchParams(window.location.search);
    const userId = projParams.get('userId');
    if (userId != null) {
      localStorage.setItem('userId', userId);
    } else {
      localStorage.getItem('userId');
    }

    this.targetPage();
    this.envUrlDetails();
    // localStorage.setItem('environment', 'dev');
    // localStorage.setItem('urlDomain', 'sb-unilever-claims.veevavault.com');
    // localStorage.setItem('environment', 'qa');
    // localStorage.setItem('urlDomain', 'sb-unilever-claims-qa.veevavault.com');
  }

  ngOnInit() {
    this.loadingService.setLoading(true);
    this.authService.handleRedirectObservable().subscribe();
    this.isIframe = window !== window.parent && !window.opener; // Remove this line to use Angular Universal

    this.setLoginDisplay();

    this.authService.instance.enableAccountStorageEvents(); // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.ACCOUNT_ADDED ||
            msg.eventType === EventType.ACCOUNT_REMOVED
        )
      )
      .subscribe((result: EventMessage) => {
        if (this.authService.instance.getAllAccounts().length === 0) {
          window.location.pathname = '/';
        } else {
          this.setLoginDisplay();
        }
      });

    //to handle login errors
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.ACQUIRE_TOKEN_FAILURE
        )
      )
      .subscribe((msg: EventMessage) => {
        const errorMessage = (msg.error as AuthError).errorMessage;
        if (errorMessage) {
          // Handle ERROR ServerError: access_denied: AADB2C90091: The user has cancelled entering self-asserted information
          if (errorMessage.indexOf('AADB2C90091') > -1) {
            this.authService.instance.loginRedirect();
          }
        }
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
      });

    //  const routePath = localStorage.getItem('routeApp');
    // if (routePath == 'EEOC') {
    if (
      sessionStorage.getItem('sessionId') == null ||
      localStorage.getItem('projectId') == null ||
      localStorage.getItem('environment') == undefined
    ) {
      this.showAccessDeneiedError();
    }
    // }

    this.loadingService.setLoading(false);
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    console.log('login display', this.loginDisplay);
  }

  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.authService.instance.getActiveAccount();
    console.log('active acc', activeAccount);
    if (
      !activeAccount &&
      this.authService.instance.getAllAccounts().length > 0
    ) {
      let accounts = this.authService.instance.getAllAccounts();
      console.log('acc info', accounts);
      console.log('active acc', activeAccount);
      this.loggedinUserName = accounts[0].name;
      sessionStorage.setItem(
        'loggedInUser',
        this.loggedinUserName.split(',')[1]
      );
      sessionStorage.setItem('username', accounts[0].username);
      this.authService.instance.setActiveAccount(accounts[0]);
    } else {
      console.log('active acc', activeAccount);
      this.loggedinUserName = activeAccount.name;
      sessionStorage.setItem(
        'loggedInUser',
        this.loggedinUserName.split(',')[1]
      );
      sessionStorage.setItem('username', activeAccount.username);
    }
  }

  loginRedirect() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginRedirect({
        ...this.msalGuardConfig.authRequest,
      } as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }

  logout(popup?: boolean) {
    if (popup) {
      this.authService.logoutPopup({
        mainWindowRedirectUri: '/',
      });
    } else {
      this.authService.logoutRedirect();
    }
  }

  /**to set target page */
  targetPage() {
    const targetPage = new URLSearchParams(window.location.search);
    const pageDetails: any = targetPage.get('targetPage');
    console.log('route url', window.location.href.split('#')[1]);
    
    const allKeys = Object.keys(localStorage);
    const beginHereKeys = allKeys.filter(key => key.startsWith('begin_here_'));
    beginHereKeys.forEach(key => localStorage.removeItem(key));

    if (
      pageDetails == 'edit_claims' ||
      window.location.href.split('#')[1] == '/edit-claims-la' ||
      window.location.href.split('#')[1] == '/edit-la-confirm' ||
      window.location.href.split('#')[1] == '/edit-claims-confirm'
    ) {
      // add route of confirmation pages of LA-claim
      this.router.navigate(['edit-claims-la']);
    } else {
      this.router.navigate(['home']);
    }
  }

  /**to get url details*/
  envUrlDetails() {
    const envParams = new URLSearchParams(window.location.search);
    const env: any = envParams.get('env');
    if (localStorage.getItem('urlDomain') != null) {
      localStorage.getItem('urlDomain');
    } else {
      localStorage.setItem('urlDomain', env);
    }

    let environment;
    if (
      localStorage.getItem('urlDomain') == 'sb-unilever-claims.veevavault.com'
    ) {
      // environment = 'dev';
      localStorage.setItem('environment', 'dev');
    } else if (
      localStorage.getItem('urlDomain') ==
      'sb-unilever-claims-sandbox--limited-release.veevavault.com'
    ) {
      // environment = 'sandbox';
      localStorage.setItem('environment', 'sandbox');
    } else if (
      localStorage.getItem('urlDomain') ==
      'sb-unilever-claims-qa.veevavault.com'
    ) {
      // environment = 'qa';
      localStorage.setItem('environment', 'qa');
    } else if (
      localStorage.getItem('urlDomain') ==
      'sb-unilever-claims-training.veevavault.com'
    ) {
      // environment = 'trn';
      localStorage.setItem('environment', 'trn');
    } else if (
      localStorage.getItem('urlDomain') == 'unilever-bbfclaims.veevavault.com'
    ) {
      // environment = 'prod';
      localStorage.setItem('environment', 'prod');
    }
  }

  // to show access denied popup when user trying Sparci URL directly
  showAccessDeneiedError() {
    console.log(
      'You will be able to access SPARCi only via a Project in Veeva Claims.'
    );
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    (dialogConfig.height = '260px'),
      (dialogConfig.width = '345px'),
      (dialogConfig.data = {
        icon: '../../../assets/images/icons/access-denied.png',
        method: 'redirect',
        message:
          'You will be able to access SPARCi only via a Project in Veeva Claims.',
        type: PopupType.ERROR,
      } as any);
    this.dialog
      .open(AccessDeniedPopupComponent, dialogConfig)
      .afterClosed()
      .subscribe((response) => {});
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
